<div mat-dialog-title>Edit Task Rating</div>
<mat-dialog-content>
   <div class="breadcrumbs">
      <div class="breadcrumb-text">
         {{ selectedTask?.businessUnit?.name }}
      </div>
      <mat-icon class="breadcrumb-icon">chevron_right</mat-icon>

      <div class="breadcrumb-text">
         {{ selectedTask?.department?.name }}
      </div>
      <mat-icon class="breadcrumb-icon">chevron_right</mat-icon>

      <div class="breadcrumb-text">
         {{ selectedTask?.departmentFunction?.name }}
      </div>
      <mat-icon class="breadcrumb-icon">chevron_right</mat-icon>
   </div>
   <div class="task-name">{{ selectedTask?.task.name }}</div>
   <div class="rating-row">
      <div class="task-rating">
         <mat-form-field class="rating-select">
            <mat-label>Rating</mat-label>
            <mat-select [(ngModel)]="selectedTask.taskRating.rating">
               <mat-option *ngFor="let level of competencyLevels" [value]="level.value">
                  {{ level.label }}
               </mat-option>
            </mat-select>
         </mat-form-field>
         <mat-form-field class="rating-description">
            <mat-label>Rating Level Description</mat-label>
            <textarea matInput readonly>{{ ratingDescription() }}</textarea>
         </mat-form-field>
      </div>
      <div class="task-competencies">
         <mat-form-field class="fill-height" floatLabel="always">
            <mat-label>Task Competencies Description</mat-label>
            <textarea matInput readonly class="hidden-textarea"></textarea>
            <div class="task-competencies-text" [innerHTML]="selectedTask.task.competencies"></div>
         </mat-form-field>
      </div>
   </div>
   <div class="notes">
      <app-text-editor
         label="Notes"
         [config]="notesEditorConfig"
         [(value)]="selectedTask.taskRating.notes"
         [canEdit]="true"
      ></app-text-editor>
   </div>
</mat-dialog-content>
<mat-dialog-actions>
   <button mat-raised-button color="primary" (click)="save()">Save</button>
   <button mat-stroked-button color="primary" (click)="cancel()">Cancel</button>
</mat-dialog-actions>

